import "./styled.css";
import { getDic } from "../../assets/i18n/dictionary";

export default function PreForm({ faceScanControl, setFaceScanControl, tryOpenCamera }) {
  return (
    <div className="div-card">
      <div className="div-iconCam">🎫</div>

      <h1 style={{ color: "#0767d8" }}>{getDic("identificacao")}</h1>

      <span>{getDic("informe-seus-dados")}</span>

      <div style={{ width: "100%", marginTop: 20, display: "flex", flexDirection: "column", gap: 12 }}>
        <input
          type="text"
          placeholder={getDic("id-do-evento")}
          value={faceScanControl.eventId}
          onChange={(e) => setFaceScanControl({ ...faceScanControl, eventId: e.target.value })}
          style={inputStyle}
        />
        <input
          type="text"
          placeholder={getDic("id-do-participante")}
          value={faceScanControl.guestId}
          onChange={(e) => setFaceScanControl({ ...faceScanControl, guestId: e.target.value })}
          style={inputStyle}
        />
      </div>

      <button className="button-takePhoto" onClick={tryOpenCamera}>
        <i style={{ marginRight: 10 }}>▶️</i>
        <span>{getDic("continuar").toUpperCase()}</span>
      </button>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "14px 16px",
  borderRadius: 12,
  border: "1px solid #cce0f5",
  fontSize: 16,
  outline: "none",
  boxSizing: "border-box",
};
